import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CompanySearchResponse } from 'src/app/models/company_search_response';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { SweetAlertService } from 'src/services/sweetAlertService';

@Component({
  selector: 'app-company-manage',
  templateUrl: './company-manage.component.html',
  styleUrls: ['./company-manage.component.css']
})
export class CompanyManageComponent {
  edit:boolean =false;
  company: CompanySearchResponse[] = [];
  registrationNumber: string = '';
  companyNationalNumber: number|undefined;

  activityForm: FormGroup;

  fields = [
    { label: 'الرقم الوطني', control: 'nationalId' },
  
    { label: 'رقم التسجيل', control: 'registrationNumber' },
  
    { label: 'اسم الشركة', control: 'companyName' },
    { label: 'اسم الشركة بالانجليزية', control: 'companyName_en' },
  
    { label: 'وصف النشاط', control: 'activityDescription' },
    { label: 'وصف النشاط بالانجليزية '  , control: 'activityDescription_en' },
  
    { label: 'موقع الشركة', control: 'companyLocation' },
    { label: 'موقع الشركة بالانجليزية', control: 'companyLocation_en' },
  
    { label: 'الرقم الضريبي', control: 'taxNumber' },
  
    { label: 'تاريخ الإصدار', control: 'issueDate' , controlType:'Date' },
  
    { label: 'تاريخ الانتهاء', control: 'expiryDate' , controlType:'Date' },
  
   
  ];
  

  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private sweetAlertService: SweetAlertService
  ) {
    const group: any = {};
    this.fields.forEach(field => {
      group[field.control] = ['', Validators.required];
    });
  
    this.activityForm = this.fb.group(group);
  
    // 👇 Subscribe to form changes
    this.activityForm.valueChanges.subscribe((formValues) => {
      if (this.company.length > 0) {
        const company = this.company[0]; // Assuming only one company record to edit
  
        company.companyNationalNumber = formValues.nationalId;
        company.registrationNumber = formValues.registrationNumber;
        company.companyNameAr = formValues.companyName;
        company.companyNameEn = formValues.companyName_en;
        company.activityDescriptionAr = formValues.activityDescription;
        company.activityDescriptionEn = formValues.activityDescription_en;
        company.comapnyLocationAr = formValues.companyLocation;
        company.companyLocationEn = formValues.companyLocation_en;
        company.companyType = formValues.companyType;
        company.taxNumber = formValues.taxNumber;
  
        company.issueDate = formValues.issueDate;
        company.expiryDate = formValues.expiryDate;
  
      }
    });
  }
  

  clearForm(): void {
    this.activityForm.reset();
    this.registrationNumber=""; 
    this.companyNationalNumber=0;
    this.company=[];
    this.edit=false// Clears all fields to initial state (empty)
  }
  
  

  onSearch() {
   
    const queryParams = `registrationNumber=${encodeURIComponent(this.registrationNumber)}&companyNationalNumber=${encodeURIComponent(this.companyNationalNumber!)}`;

    var link="ActivtyLicense/SearchCompanies?"+queryParams;
    this.apiService.get(link,environment.getterLink).subscribe(({
      next: (response) => {
        try {

          this.company = response.companies;
  

          if (this.company && this.company.length > 0) {
            this.edit= true;
            const company = this.company[0];

  
            // Patch the form with values
            this.activityForm.patchValue({
              nationalId: company?.companyNationalNumber,
            
              registrationNumber: company.registrationNumber,
            
              companyName: company.companyNameAr,
              companyName_en: company.companyNameEn,
            
              activityDescription: company.activityDescriptionAr,
              activityDescription_en: company.activityDescriptionEn,
            
              companyLocation: company.comapnyLocationAr,
              companyLocation_en: company.companyLocationEn,
          
            
              taxNumber: company.taxNumber,
            
              issueDate: company.issueDate ? this.formatDate(company.issueDate) : '',
            
              expiryDate: company.expiryDate ? this.formatDate(company.expiryDate) : '',

            });
            
          }
  
        } catch (error) {
          this.edit= false;
          this.clearForm()
          this.sweetAlertService.ShowAlert("info","")
        
        }
      },
      error: (error) => {
        this.edit= false;
        this.clearForm()
        this.sweetAlertService.ShowAlert("info","no data found")
      
      }
    }));
  }

  editForm(){   
    
  if (this.activityForm.valid) {
    const value = this.company[0];

    var nationalNumber=this.activityForm.get('nationalId');
    var registrationNumber=this.activityForm.get('registrationNumber');
    var companyNameAr=this.activityForm.get('companyName');
    var companyNameEn=this.activityForm.get('companyName_en');
    var activityDescriptionAr=this.activityForm.get('activityDescription');
    var activityDescriptionEn=this.activityForm.get('activityDescription_en');
    var comapnyLocationAr=this.activityForm.get('companyLocation');
    var companyLocationEn=this.activityForm.get('companyLocation_en');
    var taxNumber=this.activityForm.get('taxNumber');
    var issueDate=this.activityForm.get('issueDate');
    var expiryDate=this.activityForm.get('expiryDate');

    const payload = {
      companyNationalNumber: value?.companyNationalNumber ?? nationalNumber?.value,
      registrationNumber: value?.registrationNumber ?? registrationNumber?.value,
      companyNameAr: value?.companyNameAr ?? companyNameAr?.value,
      companyNameEn: value?.companyNameEn ?? companyNameEn?.value,
      activityDescriptionAr: value?.activityDescriptionAr ?? activityDescriptionAr?.value,
      activityDescriptionEn: value?.activityDescriptionEn ?? activityDescriptionEn?.value,
      comapnyLocationAr: value?.comapnyLocationAr ?? comapnyLocationAr?.value,
      companyLocationEn: value?.companyLocationEn ?? companyLocationEn?.value,
      taxNumber: value?.taxNumber ?? taxNumber?.value,
      issueDate: value?.issueDate ?? issueDate?.value,
      expiryDate: value?.expiryDate ?? expiryDate?.value,
    };
    
    this.apiService.post("ActivtyLicense/AddEditCompanyForWeb",payload,environment.getterLink).subscribe({
      next: (response) => {
        this.sweetAlertService.ShowAlertThenRedirect("success","edit successfully",'Investment/ControlPanel/manage-company');
        // Handle success: show message, redirect, etc.
      },
      error: (error) => {
      
        this.sweetAlertService.ShowAlert("error",error)
        // Handle error: show user-friendly error message
      }
    });

  } else {
    console.log(this.activityForm.errors);
    this.activityForm.markAllAsTouched(); // Show validation errors
  }}
  

  save() {
    this.editForm();
  }
  

  private formatDate(date: Date): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
}
